import Pagination, {
  Page
} from '../../../../../components/pagination';
import Route from '../../../../../services/route'
import moment from 'moment'
import { functionsIn } from 'lodash';
import {addDays, addMinutes, format, setHours, setMinutes} from "date-fns";

const workingDays = [{
    value: '0',
    caption: 'Validade do VP'
  },
  {
    value: '1',
    caption: '1 dia'
  },
  {
    value: '5',
    caption: '5 dias'
  },
  {
    value: '10',
    caption: '10 dias'
  },
  {
    value: '15',
    caption: '15 dias'
  },
  {
    value: '30',
    caption: '30 dias'
  },
];

export default {
  components: { Pagination },
  props: ['aggregate', 'confirmRouteSelected', 'routeIdSelected'],
  data() {
    const currentDate = new Date();
    const minDate = addMinutes(currentDate, 10);
    const maxDate = setMinutes(setHours(addDays(currentDate, 30), 23), 59);
    const formattedMinDate = format(minDate, "yyyy-MM-dd'T'HH:mm");
    const formattedMaxDate = format(maxDate, "yyyy-MM-dd'T'HH:mm");
    return {
      minDate: formattedMinDate,
      maxDate: formattedMaxDate,
      dataInicioViagem: formattedMinDate,
      dataFimViagem: '',
      expirationDays: '0',
      workingDays,
      page: new Page().size(5),
      routes: undefined,
      search: '',
      loading: undefined,
      filterActive: true,
      isActiveArray: [],
      routeSelected: this.routeIdSelected ? this.routeIdSelected.routeId : undefined,
      showAlert: true,
      warning: false,
      msgStrong: 'Nova forma de consulta.',
      msgAlert: ' Para saber a relação de rotas cadastradas, faça uma pesquisa individual digitando o nome da rota ou clique na lupa com o campo vazio, para uma consulta geral.'
    }
  },
  mounted() {
    this.$store.state.route.actives = undefined;
    this.routeSelected = undefined;
    this.routes = undefined;
  },
  watch:{
    search() {
      this.page = this.page.page(1);
    },
    filterActive(){
      this.filter();
    },

    routeSelected (newVal) {
        if (!newVal) return;

        let vm = this;
        let r = _.find(this.routes, function(o){
          return o.routeId == vm.routeSelected;
        });

        if (this.dataInicioViagem) r.startToll = this.dataInicioViagem;
        if (this.dataFimViagem) r.expirationToll = this.dataFimViagem;
        this.$emit('input', r);
    },

    dataInicioViagem(newValue) {
      if (this.routeSelected && typeof this.routeSelected === 'object') {
        this.routeSelected.startToll = newValue
      }

      if (this.routeSelected){
        this.$emit('input', this.atualizarElementoRota(this.routeSelected));
      } else {
        this.$emit('input', this.routeSelected);

      }
      this.$emit('cleanErrors');
    },

    dataFimViagem(newValue) {
      if (this.routeSelected && typeof this.routeSelected === 'object') {
        this.routeSelected.expirationToll = newValue;
      }

      if (this.routeSelected){
        this.$emit('input', this.atualizarElementoRota(this.routeSelected));
      } else {
        this.$emit('input', this.routeSelected);

      }
      this.$emit('cleanErrors');
    },

    confirmRouteSelected() {
      if(this.confirmRouteSelected) {
        this.msgStrong = 'Campo obrigatório';
        this.msgAlert = 'Antes de prosseguir é necessário selecionar uma rota.';
        this.warning = true;
        this.showAlert = true;
        this.$emit('confirmRouteSelected', false);
      }
    }
  },
  computed: {
    expirationDate(){
      return moment().add(parseInt(this.expirationDays), 'd')
    },
    allRoutes(){
      return this.$store.state.route.actives;
    },
    routesPaged() {
      this.filter();
      if (this.routes && this.page) {
        for(let i=0; i<this.routes.length; i++) {
          this.$set(this.routes[i], 'open', false);
        }
        return this.routes.slice(this.page.firstIndexShown() - 1, this.page.lastIndexShown())
      }
      return undefined;
    }
  },

  methods: {
    atualizarElementoRota () {
      let vm = this;
      let r = _.find(this.routes, function(o){
        return o.routeId == vm.routeSelected;
      });

      if (this.dataInicioViagem) r.startToll = this.dataInicioViagem;
      if (this.dataFimViagem) r.expirationToll = this.dataFimViagem;
      return r;
    },
    searchRoutes() {
      this.loading = this.$store.dispatch('getRoutes', this.search).then(resp => {
        if(this.allRoutes.length !== 0) {
          this.routes = this.allRoutes;
          this.page = this.page.itemCount(this.allRoutes.length);
          this.showAlert = false;
        } else {
          this.msgStrong = 'Rota não encontrada!';
          this.msgAlert = 'Faça uma nova busca ou cadastre uma nova rota.';
          this.warning = true;
          this.showAlert = true;
        }
      });
    },

    setCurrentPage(p) {
      this.page = this.page.page(p);
      this.find();
    },

    getCity(route, type){
      let p = _.find(route.points, function(o){
        return o.type == type;
      });

      if(p)
        return p.city + ', ' + p.state;

      return "";
    },

    getAddress(route, type){
      let p = _.find(route.points, function(o){
        return o.type == type;
      });

      if(p)
        return p.address;

      return "";
    },

    filter: _.debounce(function () {
      this.search = this.search.toUpperCase();

      if(!this.allRoutes)
        return;

      if (this.search == '') {
        this.routes = this.allRoutes;
        this.page = this.page.itemCount(this.routes.length);
        if(this.routes.length === 0) {
          this.showAlert = true
        }
        return;
      }

      this.routes = this.allRoutes.filter(value => {
        let a = value.name.toUpperCase().indexOf(this.search) >= 0 || value.flexField1 && value.flexField1.toUpperCase().indexOf(this.search) >= 0 || value.flexField2 && value.flexField2.toUpperCase().indexOf(this.search) >= 0;
        let b =_.filter(value.points, (o) => {
          return o.address && o.address.toUpperCase().indexOf(this.search) >= 0;
        }).length > 0;
        return a || b;
      });

      if(this.routes.length == 0) {
        this.msgStrong = 'Rota não encontrada!';
        this.msgAlert = 'Faça uma nova busca ou cadastre uma nova rota.';
        this.warning = true;
        this.showAlert = true;
      }else {
        this.showAlert = false;
      }

      this.page = this.page.itemCount(this.routes.length);
    }, 400),
  },
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/toll-ticket/date-route.js